import { requestUrl, datasetUrl } from '@/constants/urls';
import { hasMinimumLength, removeEmpty } from '@/utils/resultsHelper';

const requestEntry = ({ request }, allowRequestLink) => (
  hasMinimumLength(request.name)
    ? { name: 'request', value: allowRequestLink ? `[${request.name}](${requestUrl(request, '#')})` : request.name }
    : null
);

const datasetEntry = ({ request: { datasets: [dataset] } }, allowDatasetLink) => {
  const { title } = dataset.catalogue;
  if (!hasMinimumLength(title)) { return null; }

  return { name: 'dataset', value: allowDatasetLink ? `[${title}](${datasetUrl(dataset, '#')})` : title };
};

const requesterEntry = ({ request: { requester: { name, email } } }) => (
  hasMinimumLength(name) ? { name: 'requester', value: `[${name}](mailto:${email})` } : null
);

const taskDescription = (task, intl, { allowRequestLink, allowDatasetLink } = {}) => {
  const items = removeEmpty([
    requestEntry(task, allowRequestLink),
    datasetEntry(task, allowDatasetLink),
    requesterEntry(task),
  ]);

  return items.map((item) => intl.formatMessage({ id: `task.description.${item.name}` }, item)).join('\n\n');
};

export default taskDescription;
